import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import MultinodePicker from "Components/CommonComponents/MultinodePicker";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import { Checkbox } from "antd";
import { useEffect } from "react";
import { Card } from "reactstrap";
import styled from "styled-components";
import { getAllNodes } from "utilFunctions/helperFunctions/utilFunctions";
import "../index.css";
const ScheduledDiv2Card = styled<any>(Card)`
  height: ${({ screen, mode }: any) =>
    ["mybatchTestSyllabus"].includes(mode)
      ? ["xs", "sm", "md"].includes(screen)
        ? "calc(100vh - 66px)"
        : "100%"
      : "100%"};

  overflow: auto;
  border: ${({ screen, mode }: any) =>
    ["lectureDetailTab", "mybatchTestSyllabus"].includes(mode)
      ? "0px"
      : ["xs", "sm", "md"].includes(screen)
      ? "0px"
      : "1px solid #AFAFAF !important"};
`;
const TreeDiv = styled<any>("div")`
  padding: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "0px" : "12px 16px"};
`;

const PlannedLectureViewCard = ({
  expandTopic,
  checkedTopicCovered,
  allCoveredTopics,
  allCourseNodes,
  handleCheckedNodes,
  handleOnlyCheckedNodes,
  handleRemoveUnCheckKey,
  handleOnlyAllCheckedNodes,
  screen,
  mode,
  isMarkedAsRevision,
  isRevisionChapterSelected,
  header,
  chapterNodeDetail,
  lecturePrecheckedNodes,
  courseNodePL,
  isPlannedMode,
  checkeds,
  setCheckeds,
  onChange,
  prevCheckedTopicCovered,
  selectedPlannedLecture,
}: any) => {
  const handleCheckedNodesCard = (data: any) => {
    handleCheckedNodes(data);
  };
  const handleOnlyCheckedNodesCard = (data: any) => {
    handleOnlyCheckedNodes(data);
  };
  const handleRemoveUnCheckKeyCard = (data: any) => {
    handleRemoveUnCheckKey(data);
  };
  const handleOnlyAllCheckedNodesCard = (data: any) => {
    handleOnlyAllCheckedNodes(data);
  };
  const checkIsExpandedPrescribed = (item: any, prescribed: any) => {
    if (prescribed.includes(String(item.key))) {
      return true;
    } else return false;
  };
  const arr: any = [];
  const getAllParentNodes = (array: any[], allNodes: any[]) => {
    array.map((ele) => {
      if (ele["children"] && ele["children"].length > 0) {
        if (checkIsExpandedPrescribed(ele, allNodes)) {
          arr.push(String(ele.key));
        }
        getAllParentNodes(ele.children, allNodes);
      }
    });
    return arr;
  };
  useEffect(() => {
    if (
      allCourseNodes &&
      allCourseNodes.length &&
      mode != "mybatchTestSyllabus"
    ) {
      const allNodes = getAllNodes(allCourseNodes).map((ele: any) =>
        String(ele.key)
      );
      const isEveryExits = allNodes
        .filter(
          (ele: any) =>
            !getAllParentNodes(allCourseNodes, allNodes).includes(ele)
        )
        .every((ele: any) => checkedTopicCovered.includes(ele));
      setCheckeds && setCheckeds(isEveryExits);
    } else {
      setCheckeds && setCheckeds(false);
    }
  }, [allCourseNodes, checkedTopicCovered]);
  const label = `${!checkeds ? "Select all" : "Deselect all"}`;
  const disableHandler = () => {
    if (allCourseNodes && allCourseNodes.length) {
      const allNodes = getAllNodes(allCourseNodes).map((ele: any) =>
        String(ele.key)
      );
      const arr: any = [];
      allNodes.forEach((ele: any) => {
        if (lecturePrecheckedNodes?.map(String).includes(ele)) {
          arr.push(ele);
        }
      });
      let val = false;
      if (lecturePrecheckedNodes && lecturePrecheckedNodes.length) {
        const lecturePrecheckedNode = lecturePrecheckedNodes.map(String);
        const isAnyExits = lecturePrecheckedNode.some((ele: any) =>
          allNodes.includes(ele)
        );
        if (!isAnyExits) {
          if (selectedPlannedLecture.isComplete == 2) {
            val = false;
          } else {
            val = true;
          }
        }
        const isAnyPrevLecture = prevCheckedTopicCovered.some((ele: any) =>
          allNodes.includes(ele)
        );
        if (!isAnyPrevLecture) {
          val = false;
        }
        return val;
      }
    }
  };
  return (
    <ScheduledDiv2Card screen={screen} mode={mode}>
      {["mybatchSyllabus", "lectureDetailTab", "mybatchTestSyllabus"].includes(
        mode
      ) && <>{header}</>}
      {!isPlannedMode &&
        ["myScheduleHome"].includes(mode) &&
        !isRevisionChapterSelected && (
          <div className="selectAllCheckBoxStyle">
            <Checkbox
              disabled={disableHandler()}
              checked={checkeds}
              onChange={onChange}
            >
              {label}
            </Checkbox>
          </div>
        )}
      {allCourseNodes != null ? (
        <TreeDiv screen={screen}>
          <MultinodePicker
            fullTree={true}
            isMarkedAsRevision={isMarkedAsRevision}
            isRevisionChapterSelected={isRevisionChapterSelected}
            expandKeys={expandTopic}
            checkedKeysList={checkedTopicCovered}
            allCoveredTopics={allCoveredTopics}
            lecturePrecheckedNodes={lecturePrecheckedNodes}
            handleRemoveUnCheckKey={(data: any) => {
              handleRemoveUnCheckKeyCard(data);
            }}
            handleCheckedNodes={(data: any) => {
              handleCheckedNodesCard(data);
            }}
            handleOnlyCheckedNodes={(data: any) => {
              handleOnlyCheckedNodesCard(data);
            }}
            handleOnlyAllCheckedNodes={(data: any) => {
              handleOnlyAllCheckedNodesCard(data);
            }}
            nodes={allCourseNodes}
            disableCheckbox={true}
            mode={mode}
            chapterNodeDetail={chapterNodeDetail}
            courseNodePL={courseNodePL}
            isPlannedMode={isPlannedMode}
          ></MultinodePicker>
        </TreeDiv>
      ) : (
        <NoResultFoundSearch
          primaryMessage="No data present"
          secondaryMessage={"No data available"}
        >
          <NoDataFoundIcon />
        </NoResultFoundSearch>
      )}
    </ScheduledDiv2Card>
  );
};
export default PlannedLectureViewCard;
